import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { IFieldSpecs } from "../interfaces/field-specs";


@Component({
    selector: 'text',
    template: `
        <form-field [formGroup]="fieldConfig.formGroup"
                    [attr.class]="fieldConfig.className"
                    [options]="fieldConfig"
                    [isInternalError]="isInternalError"
                    [isFull]="isFull">
            <mat-form-field class="text-field-container"
                [class.full]="isFull"
                floatLabel="never">
                <ng-container *ngIf="fieldConfig?.icon">
                    <fa-icon [icon]="fieldConfig.icon | iconNameToDefinition"
                             matPrefix></fa-icon>
                </ng-container>
                <ng-container *ngIf="fieldConfig?.iconDefinition">
                    <fa-icon [icon]="fieldConfig.iconDefinition"
                             matPrefix></fa-icon>
                </ng-container>
                <input #textInput
                       matInput
                       class="field text-field"
                       type="text"
                       [attr.autocomplete]="autocomplete"
                       [class.disabled]="fieldConfig.disabled"
                       [class.has-icon]="fieldConfig?.iconDefinition || fieldConfig?.icon"
                       [placeholder]="label || fieldConfig.placeholder"
                       [focusIf]="isFocusOnInput"
                       [blurIf]="isBlurOnInput"
                       [formControlName]="fieldConfig.formControlName"
                       [attr.placeholder]="fieldConfig.placeholder"
                       [attr.maxlength]="maxLength"
                       [tabindex]="fieldConfig.tabindex"
                       [readonly]="fieldConfig.disabled"
                       (focus)="onFocusInput($event)"
                       (onChange)="onChange.emit($event)"
                       (onSelect)="onFocus.emit($event)"
                       (keyup)="onKeyPress.emit($event)"
                       (blur)="blur($event)">
            </mat-form-field>
        </form-field>
    `,
    styleUrls: ["./text.component.scss"]
})

export class TextComponent implements AfterViewInit{
    @Input()
    public fieldConfig: IFieldSpecs;
    @Input()
    public maxLength: number = null;
    @Input()
    public textFormat: 'uppercase' | 'lowercase';
    @Input()
    public label: string = '';
    @Input()
    public isFull: boolean = false;
    @Input()
    public isInternalError: boolean = false;
    @Input()
    public focusOnMe: boolean = false;
    @Input()
    public autocomplete: string;

    @ViewChild('textInput')
    public textInput: ElementRef;

    @Output()
    public readonly onBlur: EventEmitter<string> = new EventEmitter();
    @Output()
    public readonly onSelect: EventEmitter<string> = new EventEmitter();
    @Output()
    public readonly onFocus: EventEmitter<string> = new EventEmitter();
    @Output()
    public readonly onChange: EventEmitter<string> = new EventEmitter();
    @Output()
    public readonly onKeyPress: EventEmitter<KeyboardEvent> = new EventEmitter();

    public isFocusOnInput: boolean = false;
    public isBlurOnInput: boolean = false;

    public ngAfterViewInit(): void {
        if(this.focusOnMe){
            this.textInput.nativeElement.focus()
        }
    }

    public onChangeProcessing(value: string): void {
        switch (this.textFormat) {
            case 'uppercase':
                this.fieldConfig.formGroup.get(this.fieldConfig.formControlName).patchValue(value.toUpperCase());
                break;
            case 'lowercase':
                this.fieldConfig.formGroup.get(this.fieldConfig.formControlName).patchValue(value.toLowerCase());
                break;
            default:
                break;
        }

        this.onChange.emit(value);
    }

    public blur(event: string): void {
        this.isFocusOnInput = false;
        this.isBlurOnInput = false;
        this.onBlur.emit(event);
    }

    public blurInput(): void {
        this.isBlurOnInput = true;
    }

    public onFocusInput(event: any) {

        this.textInput.nativeElement.select();
        this.onFocus.emit(event);
    }

    public focusInput(): void {
        this.isFocusOnInput = true;
        this.isBlurOnInput = false;
    }
}
